<ng-container *ngIf="(routerState$ | async)?.data as routerStateSnapshot">
  <router-outlet></router-outlet>
</ng-container>
